const AdminUserList = (state = [], action) => {
    switch (action.type) {
        case 'AdminUserGetAll_SUCCESS':
            return action.payload.res.data
        default:
            return state
    }
}
export default AdminUserList